<template>
    <div class="ride-details bg-white max-w-3xl mx-auto py-4 shadow rounded" v-if="removeExpiredTrips(trip.created_at)">
        <div class="border border-gray-300 rounded-lg p-3 max-w-lg mx-auto mb-1">
            <div class="flex justify-between items-center border-b border-gray-300 pb-2"
                 :class="trip?.type === 'round' ? 'justify-between' : 'justify-start'"
            >
                <div class="flex justify-start gap-1 items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M10.642 2.46875C5.86679 2.46875 1.99536 6.28854 1.99536 11C1.99536 15.7115 5.86679 19.5312 10.642 19.5312C15.4171 19.5312 19.2885 15.7115 19.2885 11C19.2885 6.28854 15.4171 2.46875 10.642 2.46875ZM14.6327 12.3125H10.642C10.4656 12.3125 10.2964 12.2434 10.1716 12.1203C10.0469 11.9972 9.97683 11.8303 9.97683 11.6562V5.75C9.97683 5.57595 10.0469 5.40903 10.1716 5.28596C10.2964 5.16289 10.4656 5.09375 10.642 5.09375C10.8184 5.09375 10.9875 5.16289 11.1123 5.28596C11.237 5.40903 11.3071 5.57595 11.3071 5.75V11H14.6327C14.8091 11 14.9783 11.0691 15.103 11.1922C15.2277 11.3153 15.2978 11.4822 15.2978 11.6562C15.2978 11.8303 15.2277 11.9972 15.103 12.1203C14.9783 12.2434 14.8091 12.3125 14.6327 12.3125Z" fill="#3A3A3A"/>
                    </svg>
                    <div class="justify-start items-center">
                        <p class="text-sm font-notoSans text-primaryBlack">ট্রিপের সময়</p>
                        <p class="text-xs font-notoSans text-primaryBlack">{{ engToBdNum(trip?.journey_date) + ' ' +  timeConvertToText(trip?.journey_time)}}</p>
                    </div>
                </div>

                <div v-if="trip?.type === 'round'" class="flex justify-start gap-1 items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M10.642 2.46875C5.86679 2.46875 1.99536 6.28854 1.99536 11C1.99536 15.7115 5.86679 19.5312 10.642 19.5312C15.4171 19.5312 19.2885 15.7115 19.2885 11C19.2885 6.28854 15.4171 2.46875 10.642 2.46875ZM14.6327 12.3125H10.642C10.4656 12.3125 10.2964 12.2434 10.1716 12.1203C10.0469 11.9972 9.97683 11.8303 9.97683 11.6562V5.75C9.97683 5.57595 10.0469 5.40903 10.1716 5.28596C10.2964 5.16289 10.4656 5.09375 10.642 5.09375C10.8184 5.09375 10.9875 5.16289 11.1123 5.28596C11.237 5.40903 11.3071 5.57595 11.3071 5.75V11H14.6327C14.8091 11 14.9783 11.0691 15.103 11.1922C15.2277 11.3153 15.2978 11.4822 15.2978 11.6562C15.2978 11.8303 15.2277 11.9972 15.103 12.1203C14.9783 12.2434 14.8091 12.3125 14.6327 12.3125Z" fill="#3A3A3A"/>
                    </svg>
                    <div class="justify-start items-center">
                        <p class="text-xs font-notoSans text-primaryBlack">ফিরার সময়</p>
                        <p class="text-xs font-notoSans text-primaryBlack">{{ engToBdNum(trip?.return_date) + ' ' +  timeConvertToText(trip?.return_time)}}</p>
                    </div>
                </div>
            </div>

            <div class="flex flex-row justify-start items-center gap-1 mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M7 12.8332C5.96944 12.8332 5.12847 12.6702 4.47708 12.3443C3.82569 12.0184 3.5 11.5981 3.5 11.0832C3.5 10.7429 3.64097 10.4464 3.92292 10.1936C4.20486 9.94081 4.59375 9.7415 5.08958 9.59567L5.425 10.704C5.25972 10.7526 5.10903 10.8135 4.97292 10.8866C4.83681 10.9597 4.74444 11.0252 4.69583 11.0832C4.82222 11.2387 5.11389 11.3748 5.57083 11.4915C6.02778 11.6082 6.50417 11.6665 7 11.6665C7.49583 11.6665 7.97475 11.6082 8.43675 11.4915C8.89875 11.3748 9.19275 11.2387 9.31875 11.0832C9.27014 11.0248 9.17778 10.9591 9.04167 10.886C8.90556 10.8129 8.75486 10.7522 8.58958 10.704L8.925 9.59567C9.42083 9.7415 9.80739 9.94081 10.0847 10.1936C10.3619 10.4464 10.5004 10.7429 10.5 11.0832C10.5 11.5984 10.1743 12.019 9.52292 12.3449C8.87153 12.6708 8.03056 12.8336 7 12.8332ZM7 11.0832C6.89306 11.0832 6.79583 11.0515 6.70833 10.9881C6.62083 10.9247 6.55764 10.8397 6.51875 10.7332C6.29514 10.0429 6.01319 9.46442 5.67292 8.99775C5.33264 8.53109 5.00208 8.08386 4.68125 7.65609C4.37014 7.22831 4.10044 6.78595 3.87217 6.329C3.64389 5.87206 3.52956 5.30817 3.52917 4.63734C3.52917 3.66511 3.86458 2.84359 4.53542 2.17275C5.20625 1.50192 6.02778 1.1665 7 1.1665C7.97222 1.1665 8.79375 1.50192 9.46458 2.17275C10.1354 2.84359 10.4708 3.66511 10.4708 4.63734C10.4708 5.30817 10.359 5.87206 10.1354 6.329C9.91181 6.78595 9.63958 7.22831 9.31875 7.65609C9.00764 8.08386 8.67961 8.53109 8.33467 8.99775C7.98972 9.46442 7.70525 10.0429 7.48125 10.7332C7.44236 10.8401 7.37917 10.9253 7.29167 10.9887C7.20417 11.0521 7.10694 11.0836 7 11.0832ZM7 5.87692C7.34028 5.87692 7.63194 5.75539 7.875 5.51234C8.11806 5.26928 8.23958 4.97761 8.23958 4.63734C8.23958 4.29706 8.11806 4.00539 7.875 3.76234C7.63194 3.51928 7.34028 3.39775 7 3.39775C6.65972 3.39775 6.36806 3.51928 6.125 3.76234C5.88194 4.00539 5.76042 4.29706 5.76042 4.63734C5.76042 4.97761 5.88194 5.26928 6.125 5.51234C6.36806 5.75539 6.65972 5.87692 7 5.87692Z" fill="#9D9D9D"/>
                </svg>
                <span class="text-xs text-grayThree font-notoSans">{{ $t("triCreateForm.pickupLocation") }}</span>
            </div>

            <div class="bg-gray-100 rounded m-1">
                <p class="text-primaryBlack font-notoSans text-xs p-0.5 px-1.5">
                    {{ trip?.pickup_full_address }}
                </p>
            </div>

            <div v-if="trip?.via_full_address" class="flex flex-row justify-start items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <circle cx="7" cy="7" r="4.5" stroke="#BBC6D0"/>
                </svg>
                <span class="text-xs text-grayThree font-notoSans">{{ $t("triCreateForm.viaLocation") }}</span>
            </div>

            <div v-if="trip?.via_full_address" class="bg-gray-100 rounded m-1">
                <p class="text-primaryBlack font-notoSans text-xs p-0.5 px-1.5">
                    {{ trip?.via_full_address }}
                </p>
            </div>

            <div class="flex flex-row justify-start items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M3 1V13V1ZM11 7.46154H3V1H11L8.33333 4.23077L11 7.46154Z" fill="#9D9D9D"/>
                    <path d="M3 1V13M3 1V7.46154H11L8.33333 4.23077L11 1H3Z" stroke="#9D9D9D" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="text-xs text-grayThree font-notoSans">{{ $t("triCreateForm.destinationLocation") }}</span>
            </div>

            <div class="bg-gray-100 rounded m-1">
                <p class="text-primaryBlack font-notoSans text-xs p-0.5 px-1.5">
                    {{ trip?.destination_full_address }}
                </p>
            </div>

            <div class="flex justify-around bg-gray-100 mt-4 rounded">
                <div class="flex justify-center gap-1 w-1/2 py-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M6.91481 1.75421C5.34244 1.73054 3.15824 1.76514 2.70855 3.00355L1.60369 5.66139C1.55469 5.60392 1.49042 5.56232 1.41874 5.54167L0.973909 5.41337C0.924996 5.39915 0.873825 5.39498 0.823333 5.40109C0.772842 5.4072 0.724024 5.42347 0.679683 5.44897C0.635341 5.47447 0.596349 5.50869 0.564944 5.54968C0.533538 5.59067 0.510339 5.63762 0.496677 5.68782L0.264609 6.53262C0.25076 6.58275 0.246703 6.6352 0.252671 6.68694C0.258639 6.73869 0.274515 6.78872 0.299387 6.83416C0.32426 6.8796 0.357639 6.91956 0.397611 6.95175C0.437583 6.98394 0.483361 7.00772 0.532318 7.02172L0.977284 7.15016C0.992135 7.15431 1.00698 7.15569 1.02184 7.15819C0.936784 7.37547 0.883863 7.61435 0.883863 7.75649V10.8456C0.883863 11.0039 0.948664 11.0773 1.05154 11.1116V11.9345C1.05138 12.0076 1.06529 12.0799 1.09249 12.1475C1.11969 12.215 1.15963 12.2763 1.21002 12.328C1.2604 12.3797 1.32025 12.4206 1.38612 12.4485C1.45199 12.4764 1.52258 12.4906 1.59384 12.4905H3.04876C3.12002 12.4906 3.19061 12.4764 3.25648 12.4485C3.32234 12.4206 3.38219 12.3797 3.43258 12.328C3.48297 12.2763 3.52291 12.215 3.5501 12.1475C3.5773 12.0799 3.59122 12.0076 3.59106 11.9345V11.1418H10.4091V11.9345C10.4089 12.0076 10.4229 12.0799 10.4501 12.1475C10.4773 12.215 10.5173 12.2763 10.5677 12.328C10.6181 12.3796 10.6779 12.4206 10.7438 12.4485C10.8097 12.4763 10.8802 12.4906 10.9515 12.4905H12.4062C12.4774 12.4906 12.548 12.4764 12.6139 12.4485C12.6798 12.4206 12.7397 12.3797 12.7901 12.328C12.8405 12.2764 12.8804 12.215 12.9077 12.1475C12.9349 12.08 12.9488 12.0076 12.9487 11.9345V11.1117C13.0517 11.0774 13.1161 11.0041 13.1161 10.8457V7.75663C13.1161 7.61449 13.0631 7.37561 12.9782 7.15832C12.993 7.15597 13.0079 7.15459 13.0227 7.1503L13.4678 7.02186C13.5168 7.00784 13.5625 6.98405 13.6025 6.95186C13.6424 6.91966 13.6758 6.8797 13.7007 6.83426C13.7255 6.78882 13.7414 6.7388 13.7473 6.68706C13.7533 6.63532 13.7492 6.58288 13.7354 6.53275L13.5036 5.68796C13.4899 5.63775 13.4667 5.5908 13.4353 5.54981C13.4039 5.50882 13.3649 5.47459 13.3205 5.4491C13.2761 5.4236 13.2273 5.40733 13.1768 5.40122C13.1263 5.39511 13.0751 5.39929 13.0262 5.41351L12.5814 5.54181C12.5097 5.56254 12.4454 5.60412 12.3963 5.66152L11.2914 3.00369C10.8095 1.74646 8.48718 1.77787 6.91481 1.75421ZM11.4181 5.82927C11.4443 5.90898 11.366 5.96213 11.284 5.96697C11.284 5.96697 11.0162 5.99023 10.6468 6.02081C10.3657 5.34763 9.71259 4.8732 8.9559 4.8732C8.12551 4.8732 7.42053 5.44479 7.1944 6.22315C7.13176 6.22398 7.05899 6.22675 7.0008 6.22675C5.57019 6.22675 2.71598 5.96697 2.71598 5.96697C2.63416 5.96199 2.55573 5.90885 2.58192 5.82927C3.6811 2.39403 3.71391 2.65229 6.93924 2.68841C10.1644 2.72439 10.1832 2.47901 11.4181 5.82927ZM8.9559 5.52243C9.15503 5.52173 9.3512 5.57185 9.52672 5.66828C9.70223 5.76471 9.85157 5.90441 9.96126 6.07479C9.31528 6.12392 8.57182 6.17416 7.87899 6.20336C7.97869 5.99819 8.13237 5.82569 8.32267 5.70536C8.51298 5.58504 8.73232 5.52167 8.9559 5.52243ZM1.51986 6.63725C1.52958 6.65206 1.53903 6.66686 1.54983 6.68112H1.50798L1.51986 6.63725ZM2.23456 7.50003C2.51752 7.49533 4.03657 8.01945 4.03657 8.01945C4.22624 8.07426 4.39324 8.44185 4.3923 8.64391C4.38946 9.32443 2.67655 9.08818 1.98116 9.09094C1.93443 9.09104 1.88814 9.08167 1.84495 9.06338C1.80176 9.0451 1.76252 9.01825 1.72947 8.98438C1.69642 8.95052 1.67022 8.91029 1.65236 8.86602C1.63451 8.82175 1.62536 8.7743 1.62543 8.7264V7.86486C1.62543 7.66279 1.95159 7.50502 2.23456 7.50003ZM11.7654 7.50003C12.0484 7.50488 12.3746 7.66279 12.3746 7.86486V8.7264C12.3746 8.77431 12.3655 8.82178 12.3477 8.86607C12.3298 8.91035 12.3036 8.95059 12.2706 8.98447C12.2375 9.01836 12.1983 9.04521 12.1551 9.06351C12.1119 9.0818 12.0656 9.09117 12.0188 9.09108C11.3236 9.08832 9.61053 9.32443 9.60769 8.64391C9.60675 8.44185 9.77375 8.07426 9.96342 8.01945C9.96342 8.01945 11.4825 7.49533 11.7654 7.50003Z" fill="#242526"/>
                    </svg>
                    <span class="text-xs text-grayThree font-notoSans capitalize">
                        {{ getTripCarType(trip.car_type) }}
                    </span>
                </div>

                <div class="flex justify-center gap-1 bg-black w-1/2 py-2 rounded-r">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="16" viewBox="0 0 23 16" fill="none">
                        <path d="M7.25354 2.00392C5.7782 1.98188 3.72878 2.0141 3.30684 3.16713L2.27016 5.64172C2.22418 5.58821 2.16388 5.54948 2.09662 5.53026L1.67924 5.41081C1.63334 5.39757 1.58533 5.39368 1.53796 5.39937C1.49058 5.40506 1.44477 5.42021 1.40317 5.44395C1.36156 5.46769 1.32498 5.49956 1.29551 5.53772C1.26604 5.57588 1.24428 5.61959 1.23146 5.66633L1.01371 6.45288C1.00071 6.49956 0.996906 6.54839 1.00251 6.59657C1.00811 6.64475 1.023 6.69133 1.04634 6.73364C1.06968 6.77595 1.101 6.81315 1.1385 6.84312C1.17601 6.87309 1.21896 6.89523 1.2649 6.90827L1.68241 7.02785C1.69634 7.03172 1.71027 7.033 1.72421 7.03532C1.6444 7.23763 1.59475 7.46004 1.59475 7.59238V10.4685C1.59475 10.6159 1.65555 10.6842 1.75208 10.7162V11.4824C1.75193 11.5504 1.76498 11.6178 1.7905 11.6806C1.81602 11.7435 1.8535 11.8006 1.90078 11.8487C1.94806 11.8968 2.00421 11.9349 2.06601 11.9609C2.12781 11.9869 2.19405 12.0002 2.26091 12H3.62605C3.69292 12.0002 3.75914 11.9869 3.82095 11.9609C3.88275 11.9349 3.9389 11.8968 3.98618 11.8487C4.03346 11.8006 4.07094 11.7435 4.09646 11.6806C4.12197 11.6178 4.13503 11.5504 4.13488 11.4824V10.7443H10.5322V11.4824C10.5321 11.5504 10.5451 11.6178 10.5707 11.6806C10.5962 11.7435 10.6337 11.8006 10.681 11.8487C10.7283 11.8968 10.7844 11.9349 10.8462 11.9609C10.908 11.9868 10.9743 12.0001 11.0411 12H12.406C12.4729 12.0002 12.5391 11.9869 12.601 11.9609C12.6628 11.935 12.7189 11.8968 12.7662 11.8487C12.8135 11.8007 12.851 11.7435 12.8766 11.6807C12.9021 11.6178 12.9152 11.5504 12.9151 11.4824V10.7163C13.0118 10.6843 13.0722 10.616 13.0722 10.4686V7.59251C13.0722 7.46017 13.0224 7.23776 12.9427 7.03545C12.9567 7.03326 12.9706 7.03197 12.9845 7.02798L13.4022 6.9084C13.4481 6.89534 13.491 6.87319 13.5285 6.84322C13.566 6.81325 13.5973 6.77604 13.6206 6.73373C13.644 6.69142 13.6588 6.64485 13.6644 6.59667C13.67 6.5485 13.6662 6.49968 13.6532 6.45301L13.4357 5.66646C13.4229 5.61971 13.4011 5.576 13.3716 5.53784C13.3421 5.49968 13.3056 5.46781 13.2639 5.44407C13.2223 5.42033 13.1765 5.40518 13.1291 5.39949C13.0817 5.39381 13.0337 5.3977 12.9878 5.41094L12.5704 5.53039C12.5032 5.54969 12.4429 5.58841 12.3968 5.64185L11.3601 3.16726C10.9079 1.99671 8.72889 2.02595 7.25354 2.00392ZM11.4789 5.79803C11.5035 5.87225 11.43 5.92173 11.3531 5.92624C11.3531 5.92624 11.1018 5.94788 10.7552 5.97636C10.4915 5.34959 9.87868 4.90788 9.16869 4.90788C8.38953 4.90788 7.72805 5.44005 7.51588 6.16475C7.4571 6.16553 7.38883 6.1681 7.33423 6.1681C5.99189 6.1681 3.31381 5.92624 3.31381 5.92624C3.23705 5.9216 3.16345 5.87212 3.18802 5.79803C4.21938 2.59962 4.25016 2.84009 7.27647 2.87372C10.3027 2.90722 10.3202 2.67874 11.4789 5.79803ZM9.16869 5.51235C9.35553 5.51169 9.53959 5.55835 9.70428 5.64814C9.86896 5.73792 10.0091 5.86798 10.112 6.02662C9.50589 6.07236 8.80831 6.11914 8.15823 6.14633C8.25177 5.9553 8.39597 5.7947 8.57453 5.68267C8.75309 5.57063 8.9589 5.51164 9.16869 5.51235ZM2.1915 6.5503C2.20062 6.56409 2.20949 6.57787 2.21962 6.59115H2.18035L2.1915 6.5503ZM2.8621 7.3536C3.1276 7.34922 4.5529 7.83721 4.5529 7.83721C4.73087 7.88824 4.88757 8.23049 4.88668 8.41862C4.88402 9.05222 3.27682 8.83226 2.62433 8.83484C2.58049 8.83492 2.53706 8.8262 2.49653 8.80918C2.45601 8.79215 2.41918 8.76715 2.38818 8.73562C2.35717 8.70409 2.33258 8.66664 2.31583 8.62542C2.29908 8.5842 2.29049 8.54003 2.29056 8.49542V7.69328C2.29056 7.50514 2.59659 7.35824 2.8621 7.3536ZM11.8048 7.3536C12.0703 7.35811 12.3764 7.50514 12.3764 7.69328V8.49542C12.3765 8.54004 12.3679 8.58423 12.3511 8.62546C12.3344 8.66669 12.3098 8.70416 12.2788 8.73571C12.2478 8.76725 12.211 8.79226 12.1704 8.80929C12.1299 8.82633 12.0865 8.83505 12.0426 8.83497C11.3902 8.83239 9.78292 9.05222 9.78026 8.41862C9.77937 8.23049 9.93606 7.88824 10.114 7.83721C10.114 7.83721 11.5393 7.34922 11.8048 7.3536Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9324 6.03818C18.8334 5.9375 18.7778 5.80096 18.7778 5.65859C18.7778 5.51622 18.8334 5.37968 18.9324 5.27899L20.5158 3.66826C20.5645 3.61698 20.6227 3.57607 20.6871 3.54793C20.7515 3.51979 20.8207 3.50498 20.8908 3.50436C20.9609 3.50374 21.0304 3.51733 21.0953 3.54432C21.1601 3.57132 21.2191 3.61119 21.2686 3.6616C21.3182 3.71201 21.3574 3.77196 21.3839 3.83794C21.4104 3.90393 21.4238 3.97463 21.4232 4.04592C21.4226 4.11721 21.408 4.18766 21.3804 4.25317C21.3527 4.31867 21.3125 4.37792 21.2621 4.42745L19.6787 6.03818C19.5797 6.13884 19.4455 6.19538 19.3055 6.19538C19.1656 6.19538 19.0314 6.13884 18.9324 6.03818Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8455 6.03818C22.7465 6.13884 22.6123 6.19538 22.4723 6.19538C22.3324 6.19538 22.1981 6.13884 22.0992 6.03818L20.5158 4.42745C20.4196 4.32619 20.3664 4.19056 20.3676 4.04978C20.3688 3.90901 20.4243 3.77434 20.5222 3.6748C20.6201 3.57525 20.7524 3.51878 20.8908 3.51756C21.0292 3.51634 21.1625 3.57045 21.2621 3.66826L22.8455 5.27899C22.9444 5.37968 23 5.51622 23 5.65859C23 5.80096 22.9444 5.9375 22.8455 6.03818Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8889 4.58476C21.0289 4.58476 21.1632 4.64133 21.2621 4.74202C21.3611 4.84271 21.4167 4.97928 21.4167 5.12167V9.41697C21.4167 9.55936 21.3611 9.69593 21.2621 9.79662C21.1632 9.89731 21.0289 9.95388 20.8889 9.95388C20.7489 9.95388 20.6147 9.89731 20.5157 9.79662C20.4167 9.69593 20.3611 9.55936 20.3611 9.41697V5.12167C20.3611 4.97928 20.4167 4.84271 20.5157 4.74202C20.6147 4.64133 20.7489 4.58476 20.8889 4.58476ZM18.6231 8.50046C18.722 8.60114 18.7776 8.73768 18.7776 8.88005C18.7776 9.02242 18.722 9.15897 18.6231 9.25965L17.0397 10.8704C16.9401 10.9682 16.8068 11.0223 16.6684 11.0211C16.5301 11.0199 16.3977 10.9634 16.2998 10.8638C16.202 10.7643 16.1465 10.6296 16.1452 10.4889C16.144 10.3481 16.1972 10.2125 16.2934 10.1112L17.8768 8.50046C17.9758 8.3998 18.11 8.34326 18.2499 8.34326C18.3899 8.34326 18.5241 8.3998 18.6231 8.50046Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.71 8.50046C14.809 8.3998 14.9432 8.34326 15.0831 8.34326C15.2231 8.34326 15.3573 8.3998 15.4563 8.50046L17.0397 10.1112C17.0901 10.1607 17.1303 10.22 17.158 10.2855C17.1856 10.351 17.2002 10.4214 17.2008 10.4927C17.2014 10.564 17.1881 10.6347 17.1615 10.7007C17.135 10.7667 17.0958 10.8266 17.0462 10.877C16.9967 10.9275 16.9377 10.9673 16.8729 10.9943C16.808 11.0213 16.7385 11.0349 16.6684 11.0343C16.5984 11.0337 16.5291 11.0188 16.4647 10.9907C16.4003 10.9626 16.3421 10.9217 16.2934 10.8704L14.71 9.25965C14.611 9.15897 14.5555 9.02242 14.5555 8.88005C14.5555 8.73768 14.611 8.60114 14.71 8.50046Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6665 9.95388C16.5266 9.95388 16.3923 9.89731 16.2933 9.79662C16.1944 9.69593 16.1387 9.55936 16.1387 9.41697V5.12167C16.1387 4.97928 16.1944 4.84271 16.2933 4.74202C16.3923 4.64133 16.5266 4.58476 16.6665 4.58476C16.8065 4.58476 16.9408 4.64133 17.0398 4.74202C17.1387 4.84271 17.1943 4.97928 17.1943 5.12167V9.41697C17.1943 9.55936 17.1387 9.69593 17.0398 9.79662C16.9408 9.89731 16.8065 9.95388 16.6665 9.95388Z" fill="white"/>
                    </svg>
                    <span class="text-xs text-white font-notoSans capitalize">{{ trip?.type === 'round' ? 'রাউন্ড ট্রিপ' : 'ওয়ান ওয়ে' }}</span>
                </div>
            </div>

            <div v-if="statusTripShow(trip?.status)" class="flex justify-around bg-greenLight mt-4 rounded">
                <div v-if="trip?.status === 'active'" class="flex justify-center gap-1 w-2/3 py-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="#4CBC48" fill-opacity="0.5"/>
                        <circle cx="9.99987" cy="9.99993" r="5.71429" fill="#4CBC48"/>
                    </svg>
                    <span class="text-xs text-grayThree font-notoSans">অবশিষ্ট সময়--</span>
                    <span class="text-xs text-greenDeep font-notoSans">{{ engToBdNum(minutes + ':' + seconds) }}</span>
                </div>

                <div @click="handlePassengerBookingModal(trip?.id)"
                     class="flex justify-center gap-1 bg-greenDeep w-1/3 py-2 rounded cursor-pointer"
                >

                    <span v-if="routeName === 'BookingConfirmed' || routeName === 'ProviderBookingFeed'" class="text-xs text-white font-notoSans">বিস্তারিত</span>
                    <span v-else class="text-xs text-white font-notoSans">বিড করুন</span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_1068_1546)">
                            <path d="M7.5 11.6666C7.5 13.0475 9.73833 14.1666 12.5 14.1666C15.2617 14.1666 17.5 13.0475 17.5 11.6666C17.5 10.2858 15.2617 9.16663 12.5 9.16663C9.73833 9.16663 7.5 10.2858 7.5 11.6666Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.5 11.6666V15C7.5 16.38 9.73833 17.5 12.5 17.5C15.2617 17.5 17.5 16.38 17.5 15V11.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.5 5C2.5 5.89333 3.45333 6.71833 5 7.165C6.54667 7.61167 8.45333 7.61167 10 7.165C11.5467 6.71833 12.5 5.89333 12.5 5C12.5 4.10667 11.5467 3.28167 10 2.835C8.45333 2.38833 6.54667 2.38833 5 2.835C3.45333 3.28167 2.5 4.10667 2.5 5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.5 5V13.3333C2.5 14.0733 3.14333 14.5417 4.16667 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.5 9.16663C2.5 9.90663 3.14333 10.375 4.16667 10.8333" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1068_1546">
                                <rect width="20" height="20" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
<!--        <div
            class="mt-2 min-h-[180px] relative pb-3"
            :class="trip?.type === 'round' ? 'border-2 border-red-500 rounded bg-red-100 shadow-cyan-500/50' : 'shadow-card bg-white rounded-t-md'"
        >
            <div class="flex justify-between items-center rounded-t-md bg-whiteBlue">
                <div class="flex justify-between items-center">
                    <div
                        class="bg-primaryLight sm:pl-4 pl-1 py-2 sm:text-sm text-xs relative text-white uppercase font-sans border-r-14 border-primaryLight"
                        :class="trip?.type === 'round' ? '' : 'rounded-tl-md'"
                    >
                        <span class="mdi mdi-calendar text-mr-1"></span>
                        {{ engToBdNum(trip?.journey_date) }}

                        <span class="mdi mdi-clock mr-1"></span>
                        {{ timeConvertToText(trip?.journey_time) }}
                        <div
                            class="absolute top-0 -right-6 bg-primaryLight w-5 h-full transform -skew-x-30"
                        ></div>
                    </div>
                    <div class="hidden md:flex items-center pl-8"></div>

                    <div
                        class="hidden md:flex items-center mx-4"
                        v-if="trip && trip?.type === 'round'"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-repeat round-signal"
                        >
                            <polyline points="17 1 21 5 17 9"></polyline>
                            <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                            <polyline points="7 23 3 19 7 15"></polyline>
                            <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                        </svg>
                        <div class="mr-3">
                            <span class="mdi mdi-calendar-blank text-mr-1"></span>
                            <span class="text-bluishBlack font-medium uppercase text-sm">{{
                                    engToBdNum(trip?.return_date)
                                }}</span>
                        </div>
                        <div>
                            <span class="mdi mdi-clock-time-five text-primary mr-1"></span>
                            <span class="text-bluishBlack font-medium uppercase text-sm">{{
                                    timeConvertToText(trip?.return_time)
                                }}</span>
                        </div>
                    </div>
                </div>
                <div class="pr-2 flex justify-between space-x-2">
                    <div class="notification inline-block px-2 sm:px-4 md:px-6">
                        <slot name="notification"></slot>
                    </div>
                    <p
                        v-if="trip.status === 'active'"
                        class="bg-primaryLight text-white text-center text-xs px-3 py-1 rounded-sm"
                    >
                        <span class="mdi mdi-clock-alert mr-1"></span>
                        <span>{{ engToBdNum(minutes + ':' + seconds) }}</span>
                    </p>

                    &lt;!&ndash;<Status :status="trip.status" />&ndash;&gt;
                    &lt;!&ndash;<p
                        v-if="routeName != 'Home' && trip?.price"
                        class="text-pri-sm sm:text-pri-xs md:text-pri-md inline-block cursor-pointer"
                        @click="setDialogComponent('RentInfo')"
                    >
                        <span class="px-2 text-pri-md sm:text-pri-xs">৳{{ parseInt(trip.price) }}</span>
                        <span class="mdi mdi-information-outline text-pri-md sm:text-pri-xs"></span>
                    </p>&ndash;&gt;
                </div>
            </div>

            <div
                class="flex md:hidden px-2 mt-4"
                v-if="trip && trip?.type === 'round'"
            >
                <div class="mr-3">
                    <span class="mdi mdi-calendar-blank text-primary mr-1"></span>
                    <span class="text-bluishBlack font-medium uppercase text-sm">{{
                            engToBdNum(trip?.return_date)
                        }}</span>
                </div>
                <div>
                    <span class="mdi mdi-clock-time-five text-primary mr-1"></span>
                    <span class="text-bluishBlack font-medium uppercase text-sm">{{
                            timeConvertToText(trip?.return_time)
                        }}</span>
                    ({{ $t("returnDateTime") }})
                </div>
            </div>

            <div class="hidden md:flex gap-10 py-10 px-5">
                <div class="">
                    <div class="font-semibold text-gray-400 text-sm">
                        {{ $t("triCreateForm.pickupLocation") }}
                    </div>

                    <div class="text-bluishBlack text-sm tracking-widest font-medium my-2 break-words"
                         v-if="
                              user &&
                              user?.type === 'provider' &&
                              trip
                            "
                    >
                        {{ trip?.pickup_full_address }}
                    </div>

                    <div class="text-bluishBlack text-sm tracking-widest font-medium my-2 break-words"
                         v-if="
                          user &&
                          user?.type === 'customer' &&
                          trip
                        "
                    >
                        {{ trip?.pickup_full_address }}
                    </div>
                </div>
                <div>
                    <div class="font-semibold text-gray-400 text-sm">
                        {{ $t("triCreateForm.destinationLocation") }}
                    </div>
                    <div class="text-bluishBlack text-sm tracking-widest font-medium my-2 break-words"
                         v-if="
                          user &&
                          user?.type === 'provider' &&
                          trip
                        "
                    >
                        {{ trip?.destination_full_address }}
                    </div>

                    <div class="text-bluishBlack text-sm tracking-widest font-medium my-2 break-words"
                         v-if="
                          user &&
                          user?.type === 'customer' &&
                          trip
                        "
                    >
                        {{ trip?.destination_full_address }},
                    </div>
                </div>

                <div>
                    <div class="font-semibold text-gray-400 text-sm">
                        {{ $t("triCreateForm.numberOfPeople") }}
                    </div>
                    <div class="text-bluishBlack capitalize text-sm tracking-widest font-medium my-2">
                        {{ trip?.car_type + " " + getTripCarType(trip?.car_type) }}
                    </div>
                </div>

                <div>
                    <div class="font-semibold text-gray-400 text-sm">
                        {{ $t("triCreateForm.type") }}
                    </div>
                    <div class="text-bluishBlack text-sm tracking-widest font-medium my-2 capitalize">
                        &lt;!&ndash;{{ trip?.type.replace("e", "e ") }}&ndash;&gt;
                        {{ trip?.type === "oneway" ? $t("one_way") : $t("round_trip") }}
                    </div>
                </div>

                <div class="" v-if="trip.status === 'hold'">
                    <div class="font-semibold text-gray-400 text-sm capitalize">
                        {{ trip?.created_by }} Info
                    </div>

                    <div class="w-full">
                        <div class="text-sm font-medium my-2">
                            {{ booking?.trip?.user?.name }}
                        </div>
                        <div class="text-sm font-medium my-2 text-blue-500"
                             v-if="booking?.trip?.user?.phone"
                        >
                            <a :href="getTel(booking?.trip?.user?.phone)" class="flex gap-1 items-center">
                                <span class="mdi mdi-phone sm:hidden block"></span>
                                {{ getModifiedPhoneNumber(booking?.trip?.user?.phone) }}</a
                            >
                        </div>
                    </div>
                </div>
                <div class="absolute customer-trip-bid" :class="bookedTrip ? 'booked-trip' : ''">
                    <div>
                        <button
                            v-if="showBidingButton && !bookedTrip"
                            @click="handlePassengerBookingModal(trip?.id)"
                            class="absolute bg-primaryLight text-white text-xs px-6 py-2 rounded w-28 focus:shadow-md focus:outline-none hover:opacity-90 transition duration-500 shadow-btn"
                        >
                            <span v-if="trip.status === 'active'"> {{ $t("triCreateForm.bidNow") }} </span>
                            <span v-else>বিস্তারিত</span>
                        </button>
                        <button
                            v-if="bookedTrip && showBidingButton"
                            @click="handlePassengerBookingModal(trip?.id)"
                            class="absolute bg-green-500 text-white text-xs px-2 py-2 rounded w-64 focus:shadow-md focus:outline-none hover:opacity-90 transition duration-500 shadow-btn"
                        >
                            আপনি {{ bookedTrip.fixed_price.toLocaleString("bn-BD") }} টাকায়
                            বিড করেছেন
                            <span class="mdi mdi-arrow-right-thick"></span>
                        </button>
                    </div>
                </div>
            </div>

            &lt;!&ndash; mobile section &ndash;&gt;

            <div class="md:hidden px-3 mt-3">
                <destination-viewer :trip="trip"/>
            </div>
            <div
                class="md:hidden mt-3"
                v-if="trip?.status === 'hold' || trip?.status === 'completed'"
            >
                <div class="md:hidden flex justify-between rounded px-2">
                    <div class="flex space-x-2 bg-green-300 px-2 rounded items-center" @click="openGoogleMaps">
                        <i class="mdi mdi-directions text-green-700 text-2xl"></i>
                        <p class="text-gray-500 text-sm capitalize">{{ $t("triCreateForm.viewRoute") }}</p>
                    </div>
                </div>
            </div>
            <div class="md:hidden px-3 mt-3">
                <SeatAndTripTypeViewer
                    seatOrPassenger="Passengers"
                    :type="trip?.type"
                    :total="trip?.no_of_seat"
                    :carType="trip?.car_type"
                />
            </div>

            <div
                v-if="trip && trip?.user && trip?.user?.phone && trip.status !== 'completed'"
                class="name-and-mobile md:hidden px-3 mt-3 bg-red-50 p-3 mx-3 rounded text-sm"
            >
                <div class="name mdi mdi-account">{{ trip?.user?.name }}</div>
                <div
                    class="phone text-blue-500"
                    v-if="trip && trip?.user && trip?.user?.phone"
                >
                    <a :href="getTel(trip?.user?.phone)" class="flex gap-1 items-center">
                        <span class="mdi mdi-phone sm:hidden block"></span>
                        {{ getModifiedPhoneNumber(trip?.user?.phone) }}</a
                    >
                </div>
            </div>
            <div v-if="showCreatorInfo" class="px-3 mt-3">
                <div class="p-3 bg-green-50 boder border-2 border-green-200 md:hidden">
                    <p class="text-gray-400 text-sm">{{ $t("your_bidding") }} </p>
                    <slot name="biddingInformation"></slot>
                </div>
                <div class="absolute right-2 top-10">
                    <slot class="" name="statusChange"></slot>
                </div>
            </div>
            <div
                class="md:hidden mt-3"
                v-if="trip?.status === 'hold' || trip?.status === 'completed'"
            >
                <div class="md:hidden flex justify-between px-3 mt-3 bg-red-50 p-3 mx-3 rounded text-sm">
                    <table class="table-auto w-full">
                        <tbody>
                        <tr class="border-b-2" @click="setDialogComponent('RentInfo')">
                            <td class="text-left py-2 w-3/5">
                                ভাড়া সংগ্রহ করুন
                                <span class="text-xs">(মোট ভাড়া)</span>

                            </td>
                            <td class="text-right py-2">
                                <span>{{ (parseInt(trip.price) + parseInt(customerAmountPay)).toLocaleString("bn-BD") }} ৳</span>
                                <span class="mdi mdi-alert-circle-outline inline-block"></span>
                            </td>
                        </tr>
                        <tr v-if="parseInt(trip.promo_discount) > 0" class="border-b-2">
                            <td class="text-left py-2 w-3/5">গ্রাহক ছাড়</td>
                            <td class="text-right py-2">{{ parseInt(trip.promo_discount).toLocaleString("bn-BD") }}
                                ৳
                            </td>
                        </tr>
                        <tr v-if="parseInt(trip.promo_discount) > 0" class="border-b-2">
                            <td class="text-left py-2 w-3/5">ভাড়া সংগ্রহ করুন</td>
                            <td class="text-right py-2">
                                {{ ((parseInt(trip.price) + parseInt(customerAmountPay)) - parseInt(trip.promo_discount)).toLocaleString("bn-BD") }} ৳
                            </td>
                        </tr>
                        <tr class="border-b-2">
                            <td class="text-left py-2 w-3/5">আপনার আয়</td>
                            <td class="text-right py-2">{{ providerIncome }} ৳
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="showBidingButton && !bookedTrip" class="md:hidden flex justify-end px-3 h-10">
                <button
                    @click="handlePassengerBookingModal(trip.id)"
                    class="h-8 mt-4 -mb-10 bg-primaryLight text-white text-xs px-6 py-2 rounded w-28 focus:shadow-md focus:outline-none hover:opacity-90 transition duration-500 shadow-btn"
                >
                    <span v-if="trip.status === 'active'">
                        {{ $t("triCreateForm.bidNow") }}
                    </span>
                    <span v-else>
                        বিস্তারিত
                    </span>
                </button>
            </div>
            <div v-if="showBidingButton && bookedTrip" class="md:hidden flex justify-end px-3 h-10 mt-2">
                <button
                    @click="handlePassengerBookingModal(trip?.id)"
                    class="absolute bg-green-500 text-white text-xs px-2 py-2 rounded w-64 focus:shadow-md focus:outline-none hover:opacity-90 transition duration-500 shadow-btn"
                >
                    আপনি {{ bookedTrip.fixed_price.toLocaleString("bn-BD") }} টাকায় বিড করেছেন
                    <span class="mdi mdi-arrow-right-thick"></span>
                </button>
            </div>
            &lt;!&ndash; end mobile section &ndash;&gt;
        </div>-->
<!--        <div class="hidden md:block"
             :class="trip?.type === 'round' ? '' : 'border-b-2 border-primaryLight' "
        ></div>-->
    </div>
</template>

<script>
import UserInformation from "@/components/atom/UserInformation";
import DestinationViewer from "@/components/atom/DestinationViewer";
import SeatAndTripTypeViewer from "@/components/atom/SeatAndTripTypeViewer";
import Status from "@/components/atom/Status";
import {mapMutations} from "vuex";
import {has} from "lodash";
import {useToast} from "vue-toastification";
import engToBd from "@/mixins/engToBd";

const toast = useToast()
export default {
    name: "FeedCustomer",
    components: {
        DestinationViewer,
        UserInformation,
        SeatAndTripTypeViewer,
        Status,
    },
    mixins: [engToBd],
    props: {
        booking: {
            type: Object,
            default: {},
        },
        cars: {
            type: Object,
        },
        trip: {
            type: Object,
            default: "",
        },
        showBidingButton: {
            type: Boolean,
            default: true,
        },
        showCreatorInfo: {
            type: Boolean,
            default: false,
        },
        showRightmostImage: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            user: null,
            bookingProvider: "",
            bookedTrip: "",
            countdown: null,
            hours: 0,
            minutes: 0,
            seconds: 0,
            customerAmountPay: 0,
        };
    },

    computed: {
        routeName() {
            return this.$route.name;
        },
        tripCommission() {
            let commission = (parseInt(this.trip.price) * parseInt(this.trip.trip_payment.commission) / 100);
            let promo_discount = parseInt(this.trip.promo_discount);
            return (commission - promo_discount).toLocaleString("bn-BD");
        },
        providerIncome() {
            let heightCommission = 1000;
            let commission = (parseInt(this.trip.price) * parseInt(this.trip.trip_payment.commission) / 100);

            let minAmount = heightCommission < commission ? heightCommission : commission;
            let income = (parseInt(this.trip.price) - minAmount) + parseInt(this.customerAmountPay)
            return income.toLocaleString("bn-BD");
        },
        isLatLongExist() {
            return !!(
                this.trip?.pickup_lat &&
                this.trip?.pickup_long &&
                this.trip?.destination_lat &&
                this.trip?.destination_long
            );
            //return this.trip?.pickup_lat && this.trip?.pickup_long && this.trip?.destination_lat && this.trip?.destination_long;
        },
    },

    methods: {
        ...mapMutations({
            setTripId: "setTripId",
            setDialogComponent: "setDialogComponent",
        }),

        handlePassengerBookingModal(tripId) {
            if (this.cars && this.cars.length > 0) {
                this.$router.push({name: "TripBooking", params: {slug: tripId}});
            } else {
                //toast.error('আপনার কোন গাড়ি যুক্ত নেই ')
                //this.$router.push('/provider/car/store');
                this.$router.push({name: "TripBooking", params: {slug: tripId}});
            }
        },
        getModifiedPhoneNumber(number) {
            return number.slice(3);
        },

        getTel(number) {
            return "tel:" + number;
        },
        statusTripShow(status) {
            return status === 'active' || status === 'extended' || status === 'hold';
        },

        tripBidding(tripId, tripStatus) {
            if(tripStatus !== 'expired'){
                this.$router.push({ name: "TripBidding", params: { slug: tripId } });
            }
        },
        getTripCarType(type) {
            if (type === 'mini micro') {
                return 'মিনি মাইক্রো (৭ সিট)';
            }
            if (type === 'sedan car') {
                return 'সেডান কার (৪ সিট)';
            }
            if (type === 'premium car') {
                return 'কার (৪ সিট)';
            }
            if (type === 'micro') {
                return 'মাইক্রো (১০ সিট)';
            }
        },
        removeExpiredTrips(time) {
            const currentTime = new Date().getTime();

            const targetDateTime = new Date(time).getTime();

            const timeDifference = currentTime - targetDateTime;

            if (this.$route.name == 'Home' || this.$route.name == 'Feed') {
                if (timeDifference <= 60 * 60 * 1000) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },

        openGoogleMaps() {
            let isLatLongExist = this.isLatLongExist;
            if (isLatLongExist === false) {
                return;
            }
            const pickupLocation = `${this.trip.pickup_lat},${this.trip.pickup_long}`;
            const destinationLocation = `${this.trip.destination_lat},${this.trip.destination_long}`;
            const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${pickupLocation}&destination=${destinationLocation}`;
            window.open(googleMapsUrl, '_blank');
        }
    },

    mounted() {
        let userdata = localStorage.getItem("trip_auth_user");
        userdata = JSON.parse(userdata);
        this.user = userdata;
        this.bookingProvider = JSON.parse(localStorage.getItem('bookingProvider'))
        if (this.bookingProvider && this.bookingProvider.length > 0) {
            this.bookedTrip = this.bookingProvider.find(item => item.trip.id === this.trip.id)
        }

        this.customerAmountPay = this.trip?.trip_payment?.customer_commission ?? 0;

        this.countdown = setInterval(() => {
            const now = new Date().getTime();
            const journey_date_time = new Date(this.trip.journey_date_time).getTime();
            const created_at = new Date(this.trip.created_at).getTime();
            const hours_in_ms = 60 * 60 * 1000;
            const update_created_at = created_at + hours_in_ms;
            let distance = 0;

            if (update_created_at < journey_date_time) {
                distance = update_created_at - now;
            } else {
                distance = journey_date_time - now;
            }

            this.hours = Math.floor(distance / (1000 * 60 * 60));
            this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Add leading zero to hours, minutes, and seconds if they are single digits
            this.hours = this.hours < 10 ? "0" + this.hours : this.hours;
            this.minutes = this.minutes < 10 ? "0" + this.minutes : this.minutes;
            this.seconds = this.seconds < 10 ? "0" + this.seconds : this.seconds;

            if (distance < 0) {
                clearInterval(this.countdown);
                this.hours = 0;
                this.minutes = 0;
                this.seconds = 0;
            }
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.countdown);
    },
};
</script>

<style scoped>
@import "./feed-customer-card.styles.css";

.shadow-card {
    min-height: 180px;
}

svg.round-signal {
    color: #e11d48;
    margin-right: 12px;
}

.customer-trip-bid {
    right: 120px;
    bottom: 40px;
}

.customer-trip-bid.booked-trip {
    right: 260px;
}
</style>
